import React, {Component} from 'react';
import _ from 'lodash';
import {Field} from 'redux-form';
import SimpleTextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import Papa from 'papaparse';
import '../assets/styles/coupon-users-input.css';
import deleteIcon from '../assets/images/delete-icon.svg';

class CouponUsersHiddenInput extends Component {
    constructor(props) {
        super(props)

        this.state = {
            shortUserIds: props.shortUserIds,
        }
    }

    componentWillReceiveProps(newProps) {
        this.props.input.onChange(newProps.shortUserIds)
        this.setState({shortUserIds: newProps.shortUserIds})
    }

    render() {
        return <input
            name="shortUserIds"
            value={this.state.shortUserIds}
            type="hidden"
        />
    }
}

class CouponUsersHidden extends Component {
    constructor(props) {
        super(props)

        this.state = {
            shortUserIds: props.shortUserIds,
        }
    }

    componentWillReceiveProps(newProps) {
        this.setState({shortUserIds: newProps.shortUserIds})
    }

    validateField = (shortUserIds) => {
        if (!shortUserIds || shortUserIds.length) {
            return;
        }
        const message = 'error'
        /*this.props.setError(message);*/
        return message ? message : undefined;
    }

    render() {
        return (
            <Field
                name="shortUserIds"
                shortUserIds={this.state.shortUserIds}
                component={CouponUsersHiddenInput}
                validate={this.validateField}
            />
        )
    }
}

class CouponUsersInput extends Component {
    constructor(props) {
        super(props);

        this.state = {
            shortUserIds: [],
            singleShortUserId: '',
            errorText: null
        }

        this.singleInputRef = React.createRef()
        this.debounceSingleChange = _.debounce(this.handleSingleChange, 300)
    }

    handleSingleWithPersist = (event) => {
        event.persist();

        if (this.state.errorText) {
            this.setState(prevState => ({
                ...prevState,
                errorText: null
            }))
        }

        this.debounceSingleChange(event.target.value)
    }

    handleSingleChange = (value) => {
        if (!value) {
            return;
        }

        this.setState(prevState => ({
            ...prevState,
            singleShortUserId: value,
            errorText: value.length !== 7 ? 'User id is empty or not valid' : null
        }))
    }

    handleEnterSubmit = (event) => {
        event.persist();

        if (event.key !== 'Enter') {
            return;
        }

        event.preventDefault();

        const {singleShortUserId, shortUserIds} = this.state

        if (!singleShortUserId || singleShortUserId.length !== 7) {
            this.setState(prevState => ({
                ...prevState,
                errorText: 'User id is empty or not valid'
            }))
            return
        }

        if (shortUserIds.indexOf(singleShortUserId) !== -1) {
            this.setState(prevState => ({
                ...prevState,
                errorText: 'User id is already exists in list'
            }))
            return
        }

        this.setState(prevState => ({
            ...prevState,
            shortUserIds: [this.state.singleShortUserId].concat(prevState.shortUserIds)
        }))
        this.singleInputRef.current.input.value = '';
    }

    deleteShortUserId = (event, index) => {
        event.persist()
        event.preventDefault()

        const shortUserIds = [...this.state.shortUserIds]
        shortUserIds.splice(index, 1)

        this.setState(prevState => ({
            ...prevState,
            shortUserIds
        }))
    }

    resetShortUserIds = (event) => {
        event.persist()
        event.preventDefault()

        this.setState(prevState => ({
            ...prevState,
            shortUserIds: []
        }))
    }

    changeHandler = (event) => {
        event.persist()
        event.preventDefault()

        const shortUserIds = [...this.state.shortUserIds]

        if (!event.target.files || !event.target.files.length) {
            return
        }

        Papa.parse(event.target.files[0], {
            header: false,
            skipEmptyLines: true,
            complete: (results) => {
                event.target.value = ''
                const newShortUserIds = []

                results.data.forEach((d) => {
                    const [shortUserId] = Object.values(d)

                    if (!shortUserId || shortUserId.length !== 7 || shortUserIds.indexOf(shortUserId) !== -1 || newShortUserIds.indexOf(shortUserId) !== -1) {
                        return
                    }

                    newShortUserIds.push(shortUserId)
                });

                if (!newShortUserIds.length) {
                    return
                }

                this.setState(prevState => ({
                    ...prevState,
                    shortUserIds: newShortUserIds.concat(shortUserIds)
                }))
            },
        });
    };

    render() {
        const {
            errorText,
            shortUserIds,
        } = this.state
        return <div>
            <SimpleTextField
                floatingLabelText="User ID"
                ref={this.singleInputRef}
                onKeyPress={this.handleEnterSubmit}
                errorText={errorText}
                onChange={this.handleSingleWithPersist}
            />
            <div className="resultBlock">
                {shortUserIds.length ?
                    (<ul className="resultList">
                        {shortUserIds.slice(0, 250).map((item, index) => {
                            return <li key={item + index} className="resultListItem">
                                {item}
                                <button className="resultListItemButton" type="button" onClick={(event) => this.deleteShortUserId(event, index)}>
                                    <img src={deleteIcon} alt="Delete" />
                                    DELETE
                                </button>
                            </li>
                        })}
                    </ul>)
                    : <div className="resultText">The list of User IDs is still empty</div>
                }
            </div>
            <div className="actions">
                <RaisedButton label="RESET TEXTAREA" onClick={this.resetShortUserIds} secondary={true} labelStyle={{ fontSize: 12 }} />
                <label className="actions-upload">
                    <input
                        type="file"
                        name="file"
                        accept=".csv"
                        onChange={this.changeHandler}
                    />
                    IMPORT A CSV
                </label>
            </div>
            <CouponUsersHidden shortUserIds={shortUserIds} {...this.props} />
        </div>
    }
}

export default CouponUsersInput


// WEBPACK FOOTER //
// ./src/components/CouponUsersInput.js